import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { WA, GRAFISMO } from '../../constants';
import { ExternalLink } from '../ui';

const CTA = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-goshine-orange to-goshine-orange-dark" />
      <div className="absolute inset-0 opacity-20">
        <img src={GRAFISMO} alt="" className="w-full h-full object-cover" />
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 lg:mb-6 text-white">
          Pronto para transformar seu carro?
        </h2>
        <p className="text-sm sm:text-base lg:text-lg text-white/80 mb-6 sm:mb-8 max-w-lg lg:max-w-2xl mx-auto">
          Agende agora e descubra por que somos referência em Florianópolis.
        </p>
        <ExternalLink 
          href={WA} 
          className="inline-flex items-center gap-3 bg-white text-goshine-orange font-bold py-3 sm:py-4 lg:py-5 px-6 sm:px-8 lg:px-12 rounded-full transition-colors duration-300 hover:bg-gray-100 hover:shadow-2xl text-sm sm:text-base lg:text-lg"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="text-xl sm:text-2xl" />
          Agendar pelo WhatsApp
        </ExternalLink>
      </div>
    </section>
  );
};

export default CTA;
